// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  updatingNotesPending: false,
  toggleModulesPending: false,
  modules: [],
  categories: false,
  playlists: [],
  modulesList: [
    {
      title: 'Laying The Groundwork',
      image: '/images/modules-c1.png',
      order: 'module-1',
      modules: {
        1: { title: 'Getting Started' },
        2: { title: 'Personal Intrinsic Motivations' },
        3: { title: 'Daily Routine and Stress Triggers' },
        4: { title: 'Your Current Stress Levels & Attitude to Stress' },
        5: { title: 'Food Habits and Food Journaling' },
        6: { title: 'Preferred Diet Plan' },
        7: { title: 'Reframing What is Exercise' },
        8: { title: 'Identifying Enjoyable Physical Activities' },
        9: { title: 'How Habits Work: Triggers, Actions, And Rewards' },
        10: { title: 'Creating Time and Energy To Execute Health Goals' },
        11: { title: 'Setting S.M.A.R.T. Actionable Health Goals' },
        12: { title: 'Weighing Yourself' },
        13: { title: 'Identifying Buddy' },
      },
    },
    {
      title: 'Diet and Nutrition',
      image: '/images/modules-c2.png',
      order: 'module-2',
      modules: {
        15: { title: 'Planning for Flexibility' },
        16: { title: 'Eating Mindfully and Slowly' },
        17: { title: 'Drinking Enough Water' },
        18: { title: 'Building Up Your Meal' },
        19: { title: 'When To Have Meals' },
        20: { title: 'Differentianting Hunger, Desire and Cravings' },
        21: { title: 'Managing Hunger' },
        22: { title: 'Overcoming Cravings' },
        23: { title: 'Smart Choices: Carbohydrates' },
        24: { title: 'Smart Choices: Fats' },
        25: { title: 'Smart Choices: Salt' },
        26: { title: 'Smart Choices: Beverages' },
        27: { title: 'Smart Choices: Snacks' },
        28: { title: 'Smart Choices: Vegetarian For a Day' },
        29: { title: 'Arranging your Environment' },
        30: { title: 'Dealing with Pressure From Family And Friends' },
        32: { title: 'Healthier Fast Food Decisions' },
        33: { title: 'Making The Best of Options at Mamak/Food Court' },
        34: { title: 'Understanding Health Supplements' },
        36: { title: 'Fasting for Weight Loss' },
        37: { title: 'Planning Breakfasts' },
        39: { title: 'Nutrition for Exercise' },
        40: { title: 'Minimize Emotional Eating' },
        41: { title: 'Dealing With Weight Plateaus' },
      },
    },
    {
      title: 'Exercise and Movement',
      image: '/images/modules-c3.png',
      order: 'module-3',
      modules: {
        43: { title: 'How to Start Exercise' },
        44: { title: 'Have a Back-up Workout' },
        45: { title: 'Warming Up and Cooling Down' },
        46: { title: 'Energizing morning yoga' },
        49: { title: 'Dealing with Pain From Exercise' },
        56: { title: 'Simple bodyweight exercises' },
      },
    },
    {
      title: 'Self Care',
      image: '/images/modules-c4.png',
      order: 'module-4',
      modules: {
        57: { title: 'Building Resilience: Self Efficacy and Mindset' },
        58: { title: 'Understanding Self-Affirmations' },
        59: { title: 'Gratitude Journal' },
        60: { title: 'Recognizing Unhelpful Thoughts' },
        61: { title: 'Recognizing & Reframing Thinking Traps' },
        63: { title: 'Smarter ways of saying “No”' },
        64: { title: 'Dealing with Discouragement' },
        65: { title: 'Self-care at Work Settings' },
        66: { title: 'Deep Breathing Exercise' },
        67: { title: 'Sleep Hygiene' },
        68: { title: 'Understanding and Managing Conflicts' },
        69: { title: 'Assessing Pain' },
        70: { title: 'Managing Pain' },
        71: { title: 'Learning from Past Successes' },
        72: { title: 'Understanding Lapses and Relapses' },
        73: { title: 'Triggers and Early Warning Signs' },
        74: { title: 'Bouncing Back: Red Alert' },
        75: { title: 'The Change Process' },
      },
    },
  ],
  getModuleAnswerPending: false,
  getModuleAnswerError: null,
  toggleLockModulePending: false,
  toggleLockModuleError: null,
  updateNotesPending: false,
  updateNotesError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/modules/redux/initialState.js